import { useState } from 'react'
import { HelpCircle } from 'lucide-react'

/**
 * Inline help tooltip — hover to show explanation.
 */
export default function Tooltip({ text, children }) {
  const [show, setShow] = useState(false)

  return (
    <span className="relative inline-flex items-center">
      {children}
      <span
        className="ml-1 cursor-help text-gray-400 hover:text-gray-600 transition-colors"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
      >
        <HelpCircle className="h-3.5 w-3.5" />
      </span>
      {show && (
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-1.5 text-xs text-white bg-gray-800 rounded-lg shadow-lg whitespace-nowrap z-50 max-w-xs text-center">
          {text}
          <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-gray-800" />
        </span>
      )}
    </span>
  )
}

/**
 * First-time hint banner — dismissable.
 */
export function HintBanner({ id, children, onDismiss, dismissed }) {
  if (dismissed) return null

  return (
    <div className="bg-brand-50 border border-brand-200 rounded-lg px-4 py-3 flex items-start gap-3 text-sm">
      <span className="bg-brand-100 text-brand-600 rounded-full p-1 mt-0.5 flex-shrink-0">
        <HelpCircle className="h-4 w-4" />
      </span>
      <div className="flex-1 text-brand-800">{children}</div>
      <button
        onClick={() => onDismiss(id)}
        className="text-brand-400 hover:text-brand-600 text-xs font-medium flex-shrink-0 mt-0.5"
      >
        Got it
      </button>
    </div>
  )
}
